import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('peopleAcl', app)
  return store
}
